import {useEffect, useState} from "react";
import downIcon from "../../../../assets/images/classes/downIcon.svg";
import Modal from "../../../../components/Modal";
import Button from "../../components/Button";
import {messageToast} from "../../../../components/Toast";
import {useSetRecoilState} from "recoil";
import {lessonHomeworkState, lessonState} from "../../../../recoil/lesson/lessonState";

const SelectClassMenu = ({ classList, setClasses, mainClass, setMainClass,setStudents, savedStudents , isEditable, setIsEditable, updateStudentInfo, setUpdateStudentInfo, fetchUpdateStudents, isModStudentConsent, setIsModStudentConsent}) => {
    const [isOpen, setIsOpen] = useState(false); // 메뉴 열림 상태

    const [isModifyCheckModalOpen, setIsModifyCheckModalOpen] = useState(false);
    const [saveItem, setSaveItem] = useState(null);

    const setLessonInfoId = useSetRecoilState(lessonState);
    const setLessonHomeworkInfoId = useSetRecoilState(lessonHomeworkState);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev); // 열림/닫힘 토글
    };

    const setclasses = (item) => {
        // 모든 클래스의 representativeClass를 "N"으로 설정
        setClasses((prevClasses) =>
            prevClasses.map((cls) => ({
                ...cls,
                representativeClass: cls === item ? "Y" : "N",
            }))
        );

        // 해당 아이템만 "Y"로 설정
        setMainClass({ ...item, representativeClass: "Y" });

        scrollToTop();

        toggleDropdown();
    }

    const selectClass = (item) => {
        if(isEditable){
            if(updateStudentInfo && updateStudentInfo.length>0){
                setIsModifyCheckModalOpen(true);
                setSaveItem(item);
                return;
            }
            fetchUpdateStudents(false);
            setIsEditable(false);
        }
        if(setIsModStudentConsent){

            setIsModStudentConsent(false);
        }

        setLessonInfoId(null);
        setLessonHomeworkInfoId(null);

        setclasses(item);

    };

    // 변경된 정보 수정 저장 후 동작
    const handleSaveClick = () => {
        if(isModStudentConsent){
            if(updateStudentInfo && updateStudentInfo.length>0){
                fetchUpdateStudents(true);
            }
            setIsEditable(false);
            setclasses(saveItem);
        }else{
            messageToast({message:"학생정보 저장에 동의해주세요!",description:"동의하지 않으면 저장할 수 없습니다."});
            setIsOpen(false);
        }
        if(setIsModifyCheckModalOpen){
            setIsModifyCheckModalOpen(false);
        }
    }

    const noSaveChangeTab = () => {
        if(updateStudentInfo && updateStudentInfo.length>0){
            setStudents(savedStudents);
            setUpdateStudentInfo([]);
        }
        setIsEditable(false);
        if(setIsModifyCheckModalOpen){
            setIsModifyCheckModalOpen(false);
        }

        setclasses(saveItem);
    }

    // 스크롤 동작 함수
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto',
        });
    };

    return (
        <>
                {/* 버튼 */}
                <button
                    onClick={toggleDropdown}
                    className={`inline-flex w-full h-full justify-center items-center gap-x-1.5 transition-all duration-300 ${
                        isOpen ? "rounded-t-[34px] rounded-b-none" : "rounded-[34px]"
                    } bg-white px-3 py-2 text-lg font-bold text-[#355bdf] ring-1 ring-inset ring-gray-300 hover:bg-gray-50`}
                    style={{boxShadow:"0 2px 7px 0 rgba(0, 0, 0, 0.10)"}}
                >
                    <div className="absolute left-0 right-0 text-center">
                        {mainClass && mainClass.name}&nbsp; ({mainClass && mainClass.studentsCount}명)
                    </div>
                    <img
                        src={downIcon}
                        alt="downIcon"
                        className="ml-auto mr-[12px]"
                    />
                </button>

                {/* 드롭다운 메뉴 */}
                <div
                    className={`absolute w-full z-10 origin-top rounded-b-[34px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden ${
                        isOpen ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
                    }`}
                    style={{
                        transformOrigin: "top", // 애니메이션 시작점 설정
                    }}
                >

                    <div className="px-3 pt-1 pb-2 max-h-[300px] overflow-y-auto">
                        {classList && classList.map((item, index) => (
                            <div
                                key={index}
                                className={`flex flex-row justify-between h-[60px] items-center cursor-pointer hover:bg-gray-100 ${item && mainClass && item.classId===mainClass.classId? 'bg-[#EEF6FF]' : ''}`}
                                onClick={() => selectClass(item)}
                            >
                                <div className="text-[13px] font-normal pl-1 w-[54px]">
                                    {item.registerDate}
                                </div>
                                <div
                                    className="block px-4 py-2 text-lg max-w-[400px] truncate"
                                >
                                    {item.name}
                                </div>
                                <div
                                    className="text-[13px] font-normal pr-1  w-[54px] text-right"
                                >
                                    {item.studentsCount}명
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            {/* 정보 수정 확인 모달 */}
            <Modal
                isOpen={isModifyCheckModalOpen}
                onClose={() => setIsModifyCheckModalOpen(false)}
            >
                <h2 className="text-2xl font-bold mb-4">정보 수정</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <p className="my-8 text-xl font-normal">변경된 내용이 있습니다.<br/>저장하시겠습니까?</p>
                <div className="flex justify-center gap-4">
                    <Button
                        label="아니요"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => noSaveChangeTab()}
                    />
                    <Button label="저장하기" onClick={handleSaveClick}/>
                </div>
            </Modal>
        </>
    );
};

export default SelectClassMenu;
